"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_USER_PROFILE_CHANGED = exports.EVENT_USER_LOGGED_OUT = exports.EVENT_USER_LANGUAGE_CHANGED = void 0;
var EVENT_USER_LANGUAGE_CHANGED = 'rio.core.user.language.changed';
exports.EVENT_USER_LANGUAGE_CHANGED = EVENT_USER_LANGUAGE_CHANGED;
var EVENT_USER_LOGGED_OUT = 'rio.core.user.loggedout';
exports.EVENT_USER_LOGGED_OUT = EVENT_USER_LOGGED_OUT;
var EVENT_USER_PROFILE_CHANGED = 'rio.core.user.profile.changed';
exports.EVENT_USER_PROFILE_CHANGED = EVENT_USER_PROFILE_CHANGED;